// extracted by mini-css-extract-plugin
module.exports = {"text":"SavedFilter_text__2p9hy","savedFiltersTags":"SavedFilter_savedFiltersTags__1Ba9n","tag":"SavedFilter_tag__5K-G-","textTag":"SavedFilter_textTag__uABIa"};